import angular from 'angular';

import { BursonServiceAjs }               from './burson.service.ajs';
import { BursonSettingsCtrl }             from './burson.settings.ajs';
import { BursonStates }                   from './burson.states.ajs';
import { LegacyBursonEventsService }      from './legacy.burson.events.service';
import { LegacyBursonInvoicesService }    from './legacy.burson.invoices.service';
import { LegacyBursonRequestEventCtrl }   from './legacy.burson.request-event';
import { LegacyBursonRequestInvoiceCtrl } from './legacy.burson.request-invoice';
import { ResolveBursonOrderFailuresCtrl } from './burson.order.resolve-failures.ajs';

angular.module('workshop.burson', [])
  .config(BursonStates)
  .controller('BursonSettingsCtrl', BursonSettingsCtrl)
  .controller('LegacyBursonRequestEventCtrl', LegacyBursonRequestEventCtrl)
  .controller('LegacyBursonRequestInvoiceCtrl', LegacyBursonRequestInvoiceCtrl)
  .controller('ResolveBursonOrderFailuresCtrl', ResolveBursonOrderFailuresCtrl)
  .factory('LegacyBursonEvents', LegacyBursonEventsService)
  .factory('LegacyBursonInvoices', LegacyBursonInvoicesService)
  .service('bursonApi', BursonServiceAjs);
